module.exports = "data:image/png;base64,UklGRvwAAABXRUJQVlA4WAoAAAAQAAAAPwAAFQAAQUxQSEkAAAABN6CmbSM42am9OwQ3/RERYHxUglFsW20uYOBLoO5TDUQC8RD/Hnovu4j+TwAXKP2weatGObJ5lwBJ7JiBQu9hDRTsakD20fy/AFZQOCCMAAAA0AQAnQEqQAAWAD6RQJlIJaQioTAYCACwEglnAC7/xageYAFyP4LuDxpdsXdKRAAA/rn/eiuZIcNnMZTvZX/qYn/6mErdD36957/kBMRMy3CIizkwmchsrBIod/uULUDFYElhZIc3Nl0+2Pj3Kn0XpLiaFdL915M0NTgJ3SS/hZRD/UABUIAD3fwAAAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/RegularNode_title_highlight.png
// module id = 13
// module chunks = 0